import ActionConstants from "../action-constants";
import { createReducer } from "../utils/redux-util";
import Reducer from "./reducer";

class ApplyCouponReducer extends Reducer {
  static checkCouponData(state = initialState, action) {
    return {
      ...state,
      couponSummary: {
        couponData: {
          isCoupon: action.payload.data,
        },
      },
    };
  }
}

const applyCouponActionHandlers = {
  [ActionConstants.CHECK_COUPON_DATA]: ApplyCouponReducer.checkCouponData,
};

const initialState = {
  couponSummary: {
    couponData: {
      isCoupon: false,
    },
  },
};

export const couponSummary = createReducer(
  initialState,
  applyCouponActionHandlers
);
